"use strict";

PF.BottomPanel = class BottomPanel extends PF.Widget
	{
	static get options()
		{
		return {
			dom: {
				container: undefined,
				content: undefined,
				touch: undefined
			},
			html: PF.BottomPanel.templates,
			steps: [
				// '0px', 'contentHeight|30%', '50%', '100%'
			],
			trackHeight: false,
			animTime: 250,
		};
		}

	static get templates()
		{
		return {
			panel: `
				<div class="pf-bottom-panel move">
				</div>
				`
		};
		}

	init()
		{
		this.dom.loads(this.html);

		this.dom.container.append(this.dom.panel);
		this.dom.panel.append(this.dom.content);
		this.dom.process(this.dom.content);

		if (this.dom.touch !== undefined)
			{
			this.dom.touch.on('dndStart', this.start.bind(this));
			this.dom.touch.on('dndDrag', this.drag.bind(this));
			this.dom.touch.on('dndStop', this.stop.bind(this));

			this.dom.touch.on('slideUp', () => this.setStepByDirection(-1));
			this.dom.touch.on('slideDown', () => {
				console.log('slideDown');
				this.setStepByDirection(1);
			});
			}

		this.heightObserver = new PF.HeightObserver(this.dom.content, this.heightChangeSlot.bind(this));
		this.heightObserver.start();
		}

	destroy()
		{
		this.dom.panel.remove();
		}

	heightChangeSlot()
		{
		console.log('heightChangeSlot');
		if (this.dom.panel.height() < this.dom.content.height() && this.steps[this.currentStep].startsWith('contentHeight'))
			{
			// let newHeight = Math.min(this.dom.content.height(), this.dom.container.height());
			this.setHeight(this.getStepHeight(this.currentStep));
			}
		}

	open(stepIndex = 1)
		{
		this.state = 'open';
		this.dom.panel.show();
		this.setStep(stepIndex);
		}

	close()
		{
		this.state = 'close';
		this.setHeight(0);
		setTimeout(() => this.dom.panel.hide(), this.animTime);
		}

	start(event)
		{
		this.dom.panel.removeClass('move');
		this.dom.panel.addClass('touch');
		this.y1 = event.point.top;
		this.h1 = this.dom.panel.height();
		}

	drag(event)
		{
		console.log('drag');
		event.originalEvent.preventDefault();
		let y2 = event.point.top;
		let h2 = this.h1 - y2 + this.y1;
		h2 = Math.max(h2, 0);
		h2 = Math.min(h2, this.dom.container.height());
		this.dom.panel.setHeight(h2);
		this.h1 = h2;
		this.y1 = y2;
		}

	stop(event)
		{
		console.log('stop');
		if (event.fireSlide === false)
			{
			let index = this.getStepByClosest(this.dom.panel.height());
			if (this.isIndexValid(index))
				{
				this.setStep(index);
				}
			}
		this.dom.panel.removeClass('touch');
		this.dom.panel.addClass('move');
		}

	isIndexValid(index)
		{
		return index >= 0 && index < this.steps.length;
		}

	setStepByDirection(direction)
		{
		let step = this.getStepByDirection(direction);
		this.setStep(step);
		}

	setStep(index)
		{
		this.currentStep = index;
		this.setHeight(this.getStepHeight(index));
		}

	setHeight(height)
		{
		// if (this.trackHeight)
		// 	{
		// 	this.heightObserver.stop();
		// 	}

		this.dom.panel.setHeight(height);
		// if (this.trackHeight)
		// 	{
		// 	setTimeout(() => this.heightObserver.start());
		// 	}
		}

	getStepHeight(index)
		{
		let str = this.steps[index];
		if (str.startsWith('contentHeight'))
			{
			let maxStr = str.split('|')[1];
			let max = Infinity;
			if (maxStr !== undefined)
				{
				if (maxStr.endsWith('px'))
					{
					max = parseInt(maxStr);
					}
				if (maxStr.endsWith('%'))
					{
					max = parseInt(maxStr) / 100 * this.dom.container.height();
					}
				}
			this.dom.panel.css('height', 'auto');
			let height = Math.min(this.dom.content.height(), max);
			return height;
			}
		else
			{
			if (str.endsWith('px'))
				{
				return parseInt(str);
				}
			if (str.endsWith('%'))
				{
				return parseInt(str) / 100 * this.dom.container.height();
				}
			}
		}

	getStepByDirection(direction)
		{
		let k = direction < 0 ? 1 : -1;
		let stepIndex = this.currentStep + k;
		stepIndex = Math.max(stepIndex, 0);
		stepIndex = Math.min(stepIndex, this.steps.length - 1);
		return stepIndex;
		}

	getStepByClosest(height)
		{
		let min = Infinity;
		let minStepIndex = undefined;
		for (let i = 0; i < this.steps.length; i++)
			{
			let delta = Math.abs(height - this.getStepHeight(i));
			if (min > delta)
				{
				min = delta;
				minStepIndex = i;
				}
			}
		return minStepIndex;
		}
	};


